/* global Image */
export class ImageLoader {
    static async load(url) {
        const [item, error] = await this._load(url)
        if (error) { 
            console.warn('error', error)
            return null
        }
        return item
    }
    static async _load(url) {
        const promise = new Promise((resolve, reject) => {
            const image = new Image()
            
            const onImageLoad = () => {
                removeListeners()
                resolve(image)
            }
            const onImageError = (e) => {
                removeListeners()
                reject(e)
            }
            const removeListeners = () => {
                image.removeEventListener('load', onImageLoad)
                image.removeEventListener('error', onImageError)
            }
            
            image.addEventListener('load', onImageLoad, false)
            image.addEventListener('error', onImageError, false)
            
            image.src = url
        })
        
        return promise
            .then(data => [data])
            .catch(error => [null, error])
    }
}